import promotionService from '@/services/promotion'
import Vue from 'vue'
import _ from 'lodash'
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    customer_groups: [],
    product_groups: [],
    table_list: [],
    tmp_table_list: [],
    tmp_series: [],
    options_chart: {
      title: {
        text: "BUBBLE SIZE: INCREMENTAL SALES",
        textStyle: {
          color: "#A8A8A8",
          fontSize: 16,
          align: "center"
        },
        left: "20%"
      },
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          var tooltip =
            '<span class="xxxx">' + params.value[3] + "</span><br />";
          tooltip +=
            '<p class="graph-tooltips-head">' + params.value[4] + "</p>";
          tooltip +=
            '<p class="graph-tooltips-label">Sales <span class="graph-tooltips-text">$' +
            params.value[0] +
            "</span></p>";
          tooltip +=
            '<p class="graph-tooltips-label">Outlets <span class="graph-tooltips-text">' +
            params.value[1] +
            "</span></p>";
          tooltip +=
            '<p class="graph-tooltips-label">Incremental <span class="graph-tooltips-text">' +
            params.value[5] +
            "%</span></p>";
          return tooltip;
        },
        axisPointer: {
          type: "cross",
          snap: true
        },
        backgroundColor: "rgba(255,255,255,1)",
        textStyle: {
          color: "#000"
        },
        extraCssText: "box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1); padding:14px"
      },
      grid: {
        width: "88.8%",
        left: 90
      },
      xAxis: {
        name: "SALES VOLUME",
        nameLocation: "middle",
        nameTextStyle: {
          color: "#727272",
          fontWeight: "bold",
          fontSize: "16",
          fontFamily: "roboto",
          padding: [20, 0, 0, 0]
        },
        splitNumber: 10,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          textStyle: {
            color: "#A8A8A8"
          }
        },
        splitLine: {
            lineStyle: {
                type: 'dashed'
            }
        },
        axisPointer: {
          label: {
            formatter: function (params) {
              return Math.floor(params.value, 10);
            }
          }
        }
      },
      yAxis: {
        min: -2,
        name: "NUMBER OF OUTLETS",
        nameLocation: "middle",
        nameTextStyle: {
          color: "#727272",
          fontWeight: "bold",
          fontSize: "16",
          fontFamily: "roboto",
          padding: [0, 0, 32, 0]
        },
        splitNumber: 7,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          textStyle: {
            color: "#A8A8A8"
          }
        },
        splitLine: {
            lineStyle: {
                type: 'dashed'
            }
        },
        axisPointer: {
          label: {
            formatter: function (params) {
              return Math.floor(params.value, 1);
            }
          }
        },
        scale: true
      },
      series: [{
          name: "Reference Page",
          type: "scatter",
          show: false,
          // data: [
          //   [5000000, 200, "Bangkok", "EBU_1234", "Back to school", 43],
          //   [4000000, 180, "Chiangmai", "EBU_1234", "Back to school", 91],
          //   [1500000, 40, "Nonthaburi", "EBU_1234", "Back to school", 18],
          //   [700000, 300, "Rayong", "EBU_1234", "Back to school", 57]
          // ],
          data: null,
          itemStyle: {
            color: "#52b6b0",
            opacity: 0.5
          },
          symbolSize: function (x) {
            var ss = x[5] * 1;
            return ss;
          },
          label: {
            emphasis: {
              show: true,
              formatter: "{@[3]}",
              position: "bottom",
              color: "black"
            }
          }
        },
        {
          name: "Reference Page",
          type: "scatter",
          show: false,
          data: null,
          itemStyle: {
            color: "#5daaec",
            opacity: 1
          },
          symbolSize: function (x) {
            var ss = x[5] * 1;
            return ss;
          },
          label: {
            emphasis: {
              show: true,
              formatter: "{@[3]}",
              position: "bottom",
              color: "black"
            }
          }
        },
        {
          name: "Reference Page",
          type: "scatter",
          show: false,
          data: null,
          itemStyle: {
            color: "#527de5",
            opacity: 1
          },
          symbolSize: function (x) {
            var ss = x[5] * 1;
            return ss;
          },
          label: {
            emphasis: {
              show: true,
              formatter: "{@[3]}",
              position: "bottom",
              color: "black"
            }
          }
        },
        {
          name: "Reference Page",
          type: "scatter",
          show: false,
          data: null,
          itemStyle: {
            color: "#9a67e3",
            opacity: 1
          },
          symbolSize: function (x) {
            var ss = x[5] * 1;
            return ss;
          },
          label: {
            emphasis: {
              show: true,
              formatter: "{@[3]}",
              position: "bottom",
              color: "black"
            }
          }
        }
      ]
    }
  },
  mutations: {
    setCustomerGroups(state, value) {
      state.customer_groups = value
    },
    setProductGroups(state, value) {
      state.product_groups = value
    },
    setTableList(state, value) {
      state.table_list = value
    },
    setTmpTableList(state, value) {
      state.tmp_table_list = value
    },
    setTmpValueSeries(state, value) {
      state.tmp_series = value
    },
    setValueSeries(state, value) {
      state.options_chart.series[value.index].data = value.data
    },
  },
  actions: {
    getCustomerGroups({
      commit,
      state
    }) {
      if (state.customer_groups.length == 0)
        promotionService.getCustomerGroups()
        .then((response) => {
          //console.log(response)
          commit('setCustomerGroups', _.remove(response, function (n) {
            return n.group_name != '';
          }))
        })
        .catch((error) => console.log(error))
    },
    getProductGroups({
      commit,
      state
    }) {
      if (state.product_groups.length == 0)
        promotionService.getProductGroups()
        .then((response) => {
          commit('setProductGroups', _.remove(response, function (n) {
            return n.group_name != '';
          }))
        })
        .catch((error) => console.log(error))
    },
    getChartBubble({
      commit,
      state
    }) {
      let user = Vue.$jwt.decode(localStorage.getItem('token'))
      promotionService.getChartBubble(user.code)
        .then((response) => {

          // var responses = {
          //   IS: [
          //     [5000000, 200, "", "EBU_1234", "Back to school", 43],
          //     [4000000, 180, "", "EBU_1234", "Back to school", 91],
          //     [1500000, 40, "", "EBU_1234", "Back to school", 18],
          //     [700000, 300, "", "EBU_1234", "Back to school", 57]
          //   ],
          //   IO: [
          //     [2500000, 100, "Bangkok", "EBU_1234", "Back to school", 33],
          //     [1700000, 180, "Chiangmai", "EBU_1234", "Back to school", 81]
          //   ],
          //   NP: [
          //     [1500000, 200, "Bangkok", "EBU_1234", "Back to school", 33],
          //     [2000000, 280, "Chiangmai", "EBU_1234", "Back to school", 81]
          //   ],
          //   CP: [
          //     [4000000, 300, "Bangkok", "EBU_1234", "Back to school", 33],
          //     [3000000, 280, "Chiangmai", "EBU_1234", "Back to school", 81],
          //     [1100000, 60, "Nonthaburi", "EBU_1234", "Back to school", 38],
          //     [500000, 400, "Rayong", "EBU_1234", "Back to school", 37]
          //   ]
          // }

          var responses = (response.chart !== undefined) ? response.chart : {};
          commit('setTmpValueSeries', responses);
          var grid = (response.grid !== undefined) ? response.grid : [];
          commit('setTableList', grid);
          commit('setTmpTableList', grid);

          var index = '';
          _.forEach(responses, (data, key) => {
            switch (key) {
              case 'IS':
                index = 0;
                break;
              case 'IO':
                index = 1;
                break;
              case 'NP':
                index = 2;
                break;
              case 'CP':
                index = 3;
                data = [];
            }

            commit('setValueSeries', {
              index,
              data
            });

          });

        })
        .catch((error) => console.log(error))
    },
    searchPromotion: ({
      commit,
      state
    }, {
      status,
      keyword,
      custgroup,
      prodgroup
    }) => {
      var re = new RegExp(keyword, 'gi')
      var response = _.filter(state.tmp_table_list, (item) => {
        if (status !== 'ALL') {
          /* filter with status */
          if (status === 'Active' && item.type != "Active") {
              return false;
          } else if (status === 'Draft' && item.type !== 'Draft') {
              return false;
          } else if (status === 'Pending' && item.type !== 'Pending') {
              return false;
          } else if (status === 'Return' && item.type !== 'Return') {
              return false;
          }
      }

        if (prodgroup !== '') {
          let hasProdGroup = false;
          for (let index in item.products) {
            if (item.products[index].code === prodgroup) {
              hasProdGroup = true;
              break;
            }
          }
          if (hasProdGroup === false) {
            return false;
          }
        }
        if (custgroup !== '') {
          /* filter with customer group */
          let hasCustGroup = false;
          for (let index in item.sets) {
            let set = item.sets[index];
            for (let key in set.customers) {
              if (set.customers[key]._id === custgroup) {
                hasCustGroup = true;
                break;
              }
            }
          }
          if (hasCustGroup === false) {
            return false;
          }
        }

        if (item.promo_code !== null && item.promo_code.match(re)) {
          return true
        } else if (item.promo_name !== null && item.promo_name.match(re)) {
          return true
        }
      });
      commit('setTableList', response)
    }
  },
  getters: {
    customer_groups: state => {
      return state.customer_groups
    },
    product_groups: state => {
      return state.product_groups
    },
    options_chart: state => {
      return state.options_chart
    },
    tmp_series: state => {
      return state.tmp_series
    },
    table_list: state => {
      return state.table_list
    }
  }
}
/* eslint-disable */